import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { Event } from '../types';

const EventListContext = createContext<{ eventList: Event[], loading: boolean } | undefined>(undefined);

export const useEventList = () => {
    const context = useContext(EventListContext);
    if (context === undefined) {
        throw new Error('useEventList must be used within an EventListProvider');
    }
    return context;
};

interface EventListProviderProps {
    children: ReactNode;
}

const EventListProvider: React.FC<EventListProviderProps> = ({ children }) => {
    const [eventList, setEventList] = useState<Event[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const events: Event[] = [
            {
                id: 1,
                title: 'Staring into Fear',
                date: '2026-05-15',
                endDate: '2026-05-18',
                image: '/images/events/20260515/flyer.jpg',
                location: 'Flushing Town Hall, 35 Northern Blvd, Flushing NY 11354',
                description: 'Solo art exhibition featuring KeXin Su. Opening reception 5/15/2026 at 6:00 PM. Exhibition runs 5/15 – 5/18/2026.',
                recap: {
                    summary: 'The "Staring into Fear" solo exhibition by KeXin Su at Flushing Town Hall was a profound success. The event brought together artists, teachers, and family members to celebrate Su\'s artistic journey and thematic exploration of vulnerability and resilience.',
                    photos: [
                        '/images/events/20260515/2026-exhibition-05-15/20260515_172001.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_174211.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_174254.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_174416(1).jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_175946.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_183600.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_183604.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_183616.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_183820.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_183924.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_183934.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_184241.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_185742.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_190105.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_191246.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260515_191327.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_124657.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_130513.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_140455.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_140507.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_142810.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_142822.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_143035.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_154719.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_154753.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_154832.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_155337.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_155516.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_155538.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_155903.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_155910.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_155959.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_160112.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_160120.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_160125.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_160129.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_160732.jpg',
                        '/images/events/20260515/2026-exhibition-05-15/20260517_160811.jpg'
                    ],
                    videos: [
                        { title: 'Artist Kexin (Kathy) Su speech', url: 'https://youtu.be/a7mHu2SscRo' },
                        { title: 'Teacher Kai Shi speech', url: 'https://youtu.be/rx4c0Fi6Hc4' },
                        { title: 'Co-curator DongYu Xing speech', url: 'https://youtu.be/W1KC26H7Bmk' },
                        { title: 'Parent Haijun Su speech', url: 'https://youtu.be/EYqat1c-QIw' }
                    ]
                }
            },
        ];
        setEventList(events);
        setLoading(false);
    }, []);

    return (
        <EventListContext.Provider value={{ eventList, loading }}>
            {children}
        </EventListContext.Provider>
    );
};

export default EventListProvider;
